import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface AdminGuardProps {
  children: React.ReactNode;
}

export default function AdminGuard({ children }: AdminGuardProps) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#161b22]">
        <i className="fas fa-spinner fa-spin text-[#5cb85c] text-2xl" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (profile?.role !== "admin") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#161b22]">
        <div className="w-16 h-16 bg-red-900/30 rounded-full flex items-center justify-center mb-4">
          <i className="fas fa-lock text-red-500 text-xl" />
        </div>
        <h1 className="text-xl font-bold text-gray-200 mb-2">Access Denied</h1>
        <p className="text-sm text-gray-400 mb-6">You do not have permission to access the admin panel.</p>
        <a href="/" className="px-6 py-2.5 bg-[#5cb85c] text-white text-sm font-semibold rounded-lg hover:bg-[#4cae4c] transition-all">
          Back to Home
        </a>
      </div>
    );
  }

  return <>{children}</>;
}